import React, { useState } from 'react';
import { ShieldCheck } from 'lucide-react';
import { Button } from './ui/Button';
import { trackAddToCart } from '../utils/metaPixel';
import { getCartUrl } from '../utils/cartUrls';
interface OrderBumpProps {
  bump1: boolean;
  setBump1: (v: boolean) => void;
  bump2: boolean;
  setBump2: (v: boolean) => void;
}
export function OrderBumpSection({
  bump1,
  setBump1,
  bump2,
  setBump2
}: OrderBumpProps) {
  const basePrice = 7.49;
  const bumpPrice = 9.97;
  const totalBumps = (bump1 ? bumpPrice : 0) + (bump2 ? bumpPrice : 0);
  const finalPrice = basePrice + totalBumps;
  return <section className="py-4 bg-[#F9F5F2]" data-id="element-376">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-377">
        <div className="max-w-3xl mx-auto" data-id="element-378">
          <h2 className="text-xl md:text-2xl font-serif font-bold text-sage text-center mb-1" data-id="element-379">
            🚀 Potenciá tus Resultados
          </h2>
          <p className="text-center text-sage/60 mb-5 text-xs" data-id="element-380">
            Ofertas exclusivas solo disponibles en esta página
          </p>

          {/* Bump 1 - Fermentados */}
          <div className={`rounded-2xl border-2 shadow-md mb-4 overflow-hidden cursor-pointer transition-all duration-300 ${bump1 ? 'border-emerald-600 bg-white shadow-lg' : 'border-[#D32F2F]/60 bg-white hover:border-[#D32F2F]'}`} onClick={() => setBump1(!bump1)} data-id="element-381">
            <div className={`px-4 py-2.5 flex items-center gap-2 ${bump1 ? 'bg-emerald-600' : 'bg-[#D32F2F]'} transition-colors duration-300`} data-id="element-382">
              <div className={`w-5 h-5 rounded border-2 flex items-center justify-center flex-shrink-0 ${bump1 ? 'bg-white border-white' : 'border-white/80 bg-transparent'}`} data-id="element-383">
                {bump1 && <svg className="w-3.5 h-3.5 text-emerald-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3} data-id="element-384">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-385" />
                  </svg>}
              </div>
              <span className="text-white font-bold text-sm sm:text-base leading-tight" data-id="element-386">
                ✅ SÍ, QUIERO RECONSTRUIR MI MICROBIOTA (Ahorrá 70% HOY) — Solo
                ${bumpPrice.toFixed(2)}
              </span>
            </div>

            <div className="p-5 flex flex-row gap-4 items-center" data-id="element-387">
              <div className="w-[30%] sm:w-[15%] flex-shrink-0" data-id="element-388">
                <img src="https://cdn.magicpatterns.com/uploads/x6cMPG6v6GW7Y37oKQMcJD/fermentos.png" alt="Manual de Fermentados Probióticos Ancestrales" className="w-full h-auto rounded-xl object-contain" data-id="element-389" />
              </div>
              <div className="flex-1" data-id="element-390">
                <h4 className="font-serif font-bold text-black text-lg mb-2" data-id="element-391">
                  Manual de Fermentados Probióticos Ancestrales
                </h4>
                <p className="text-sage/80 text-sm leading-relaxed" data-id="element-392">
                  <strong data-id="element-393">ADVERTENCIA:</strong> El Protocolo Reset trabaja desde
                  afuera hacia adentro. Pero si tu microbiota está destruida,
                  los resultados van a ser la mitad de rápidos. Aprendé a crear
                  Kéfir, Chucrut y Kombucha en casa para reactivar tu CMM desde
                  la raíz. Sin este paso, estás dejando el 50% de tus resultados
                  sobre la mesa.
                </p>
                <p className="text-sage/50 text-xs mt-2" data-id="element-394">
                  <span className="line-through" data-id="element-395">$37.00</span> —{' '}
                  <span className="font-bold text-sage" data-id="element-396">
                    + ${bumpPrice.toFixed(2)}
                  </span>
                </p>
              </div>
            </div>
          </div>

          {/* Bump 2 - Anti-Antojos */}
          <div className={`rounded-2xl border-2 shadow-md overflow-hidden cursor-pointer transition-all duration-300 ${bump2 ? 'border-emerald-600 bg-white shadow-lg' : 'border-[#D32F2F]/60 bg-white hover:border-[#D32F2F]'}`} onClick={() => setBump2(!bump2)} data-id="element-397">
            <div className={`px-4 py-2.5 flex items-center gap-2 ${bump2 ? 'bg-emerald-600' : 'bg-[#D32F2F]'} transition-colors duration-300`} data-id="element-398">
              <div className={`w-5 h-5 rounded border-2 flex items-center justify-center flex-shrink-0 ${bump2 ? 'bg-white border-white' : 'border-white/80 bg-transparent'}`} data-id="element-399">
                {bump2 && <svg className="w-3.5 h-3.5 text-emerald-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3} data-id="element-400">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-401" />
                  </svg>}
              </div>
              <span className="text-white font-bold text-sm sm:text-base leading-tight" data-id="element-402">
                ✅ SÍ, QUIERO APAGAR MIS ANTOJOS (Protocolo de Rescate) — Solo $
                {bumpPrice.toFixed(2)}
              </span>
            </div>

            <div className="p-5 flex flex-row gap-4 items-center" data-id="element-403">
              <div className="w-[30%] sm:w-[15%] flex-shrink-0" data-id="element-404">
                <img src="https://cdn.magicpatterns.com/uploads/9uHUCySdjqHkRx1jAeyLEv/guia.png" alt="Protocolo de Rescate Anti-Antojos" className="w-full h-auto rounded-xl object-contain" data-id="element-405" />
              </div>
              <div className="flex-1" data-id="element-406">
                <h4 className="font-serif font-bold text-black text-lg mb-2" data-id="element-407">
                  Protocolo de Rescate Anti-Antojos
                </h4>
                <p className="text-sage/80 text-sm leading-relaxed" data-id="element-408">
                  El mayor enemigo de cualquier protocolo de salud no es la
                  falta de información. Es el antojo de las 4 de la tarde que
                  arruina todo lo que hiciste bien durante el día. Este
                  protocolo te da el sistema exacto para frenar ese antojo en 60
                  segundos usando tu propia biología. Sin fuerza de voluntad. Es
                  neurociencia aplicada a tu glucosa.
                </p>
                <p className="text-sage/50 text-xs mt-2" data-id="element-409">
                  <span className="line-through" data-id="element-410">$29.00</span> —{' '}
                  <span className="font-bold text-sage" data-id="element-411">
                    + ${bumpPrice.toFixed(2)}
                  </span>
                </p>
              </div>
            </div>
          </div>

          {/* Payment Summary */}
          <div className="mt-5 bg-white rounded-2xl border-2 border-[#B2AC88]/30 shadow-md p-5" data-id="element-412">
            <div className="space-y-2 mb-3" data-id="element-413">
              <div className="flex justify-between items-center text-sm" data-id="element-414">
                <span className="text-sage line-through" data-id="element-415">
                  Protocolo Vientre Plano + 3 Bonos
                </span>
                <span className="text-sage font-semibold" data-id="element-416">
                  ${basePrice.toFixed(2)}
                </span>
              </div>

              {bump1 && <div className="flex justify-between items-center text-sm" data-id="element-417">
                  <span className="text-sage/80" data-id="element-418">
                    + Fermentados Probióticos
                  </span>
                  <span className="text-sage font-semibold" data-id="element-419">
                    ${bumpPrice.toFixed(2)}
                  </span>
                </div>}

              {bump2 && <div className="flex justify-between items-center text-sm" data-id="element-420">
                  <span className="text-sage/80" data-id="element-421">+ Guía Anti-Antojos</span>
                  <span className="text-sage font-semibold" data-id="element-422">
                    ${bumpPrice.toFixed(2)}
                  </span>
                </div>}
            </div>

            <div className="border-t border-sage/10 pt-3" data-id="element-423">
              <div className="flex justify-between items-center text-xs text-sage/50 mb-1" data-id="element-424">
                <span data-id="element-425">Valor Total:</span>
                <span className="line-through" data-id="element-426">$197.00</span>
              </div>
              <div className="flex justify-between items-center" data-id="element-427">
                <span className="font-bold text-[#D32F2F] text-base uppercase tracking-wide" data-id="element-428">
                  HOY PAGÁS SOLO:
                </span>
                <span className="font-serif font-bold text-[#D32F2F] text-2xl" data-id="element-429">
                  ${finalPrice.toFixed(2)}
                </span>
              </div>
            </div>

            <a href={getCartUrl(bump1, bump2)} onClick={e => trackAddToCart(e)} target="_blank" rel="noopener noreferrer" className="block mt-4" data-id="element-430">
              <Button size="lg" variant="primary" className="w-full shadow-gold/30 text-sm" data-id="element-431">
                COMPLETAR MI PEDIDO AHORA
              </Button>
            </a>
          </div>
        </div>
      </div>
    </section>;
}